import SaveWorkOrderRequest from "@/models/server/requests/SaveWorkOrderRequest";

export default class CreateWorkOrderRequest extends SaveWorkOrderRequest {

    public constructionSiteOrWarehouseId: string = "";

    public workOrderTypeId: string = "";

    public workOrderCreationRequestId: string | null = null;

    public inviteContactPerson: boolean = false;

    constructor(saveRequest: SaveWorkOrderRequest | null = null) {
        super();

        if (saveRequest != null) {
            this.approvalType = saveRequest.approvalType;
            this.invoiceReference = saveRequest.invoiceReference;
            this.customerApprover = saveRequest.customerApprover;
            this.customerOrderer = saveRequest.customerOrderer;
            this.activationDate = saveRequest.activationDate;
            this.completionDate = saveRequest.completionDate;
            this.plannedCompletionDate = saveRequest.plannedCompletionDate;
            this.pauseStartDate = saveRequest.pauseStartDate;
            this.pauseEndDate = saveRequest.pauseEndDate;
            this.description = saveRequest.description;
            this.distances = saveRequest.distances;
            this.equipment = saveRequest.equipment;
            this.extraCharges = saveRequest.extraCharges;
            this.rentalItems = saveRequest.rentalItems;
            this.managerId = saveRequest.managerId;
            this.salesPersonId = saveRequest.salesPersonId;
            this.approvalType = saveRequest.approvalType;
            this.mounters = saveRequest.mounters;
            this.name = saveRequest.name;
            this.workOrderId = saveRequest.workOrderId;
            this.mileagePrice = saveRequest.mileagePrice;
            this.hoursPrice = saveRequest.hoursPrice;
            this.alarmJobPrice = saveRequest.alarmJobPrice;
            this.jobSummary = saveRequest.jobSummary;
            this.fixedCost = saveRequest.fixedCost;
            this.fixedHoursCost = saveRequest.fixedHoursCost;
            this.fixedProductCost = saveRequest.fixedProductCost;
            this.fixedTransportationCost = saveRequest.fixedTransportationCost;
            this.contractType = saveRequest.contractType;
            this.deviceId = saveRequest.deviceId;
            this.costPool = saveRequest.costPool;
            this.warehouse = saveRequest.warehouse;
        }
    }
}